import { LabelValuePairsType } from 'core/types/common';

export const ORDER_TTB_STATUS = {
  AWAITING_CONFIRMATION: {
    value: 'AWAITING_CONFIRMATION',
    text: 'ordersTabTryBuy.status.awaitingConfirmation',
    color: '#FFB300',
    background: '#FFB3001A',
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    text: 'ordersTabTryBuy.status.confirmed',
    color: '#0075FF',
    background: '#0075FF1A',
  },
  DELIVERING: {
    value: 'DELIVERING',
    text: 'ordersTabTryBuy.status.delivering',
    color: '#FA541C',
    background: '#FA541C1A',
  },
  READY_TO_TRY: {
    value: 'READY_TO_TRY',
    text: 'ordersTabTryBuy.status.readyToTry',
    color: '#AB2328',
    background: '#AB23281A',
  },
  PENDING_PROCESSING: {
    value: 'PENDING_PROCESSING',
    text: 'ordersTabTryBuy.status.pendingProcessing',
    color: '#AB2328',
    background: '#AB23281A',
  },
  DELIVERY_SUCCESS: {
    value: 'DELIVERY_SUCCESS',
    text: 'ordersTabTryBuy.status.completed',
    color: '#66C11F',
    background: '#66C11F1A',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'ordersTabTryBuy.status.cancelled',
    color: '#848484',
    background: '#8484841A',
  },
};

export const DATA_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Order No',
    value: 'orderNumber',
    searchKeys: ['orderNumber'],
  },
  // {
  //   label: 'SO',
  //   value: 'saleOrderId',
  //   searchKeys: ['saleOrderId'],
  // },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['sku'],
  },
  {
    label: 'Customer Phone',
    value: 'customerPhone',
    searchKeys: ['customerPhone'],
  },
  {
    label: 'Email',
    value: 'email',
    searchKeys: ['email'],
  },
  {
    label: 'Customer name',
    value: 'customerName',
    searchKeys: ['customerName'],
  },
  {
    label: 'Shipping No',
    value: 'deliveryCode',
    searchKeys: ['deliveryCode'],
  },
];

export const ORDER_TTB_CANCEL_REASONS = [
  {
    value: 'NO_LONGER_NEEDS_IT',
    text: 'ordersTabTryBuy.reasons.noLongerNeedsIt',
  },
  {
    value: 'WANTS_TO_CHANGE_PICKUP',
    text: 'ordersTabTryBuy.reasons.wantsToChangePickup',
  },
  {
    value: 'WANTS_TO_BUY_ONLINE',
    text: 'ordersTabTryBuy.reasons.wantsToBuyOnline',
  },
  {
    value: 'OTHER',
    text: 'ordersTabTryBuy.reasons.other',
  },
];
